import { FaWallet } from "react-icons/fa";
import { IoSettings } from "react-icons/io5";
import { FaChartLine } from "react-icons/fa";

///images

import img1 from "../../../assets/images/1.webp"
import img5 from "../../../assets/images/5.webp"
import img7 from "../../../assets/images/7.webp"
import img4 from "../../../assets/images/4.webp"


export const keyFeaturesData = {

  featuresCards:
    [
      {
        title: 'Fast Execution',
        description: 'Our bot uses private Tools on Solana, ensuring lightning-fast trade execution and the ability to pick up trades faster than anyone else.'
      },
      {
        title: 'Fully Automated',
        description: 'The bot Picks up trades on your behalf , allowing for a completely hands-off trading experience.'
      },
      {
        title: 'AI Powered',
        description: 'Leveraging advanced AI technology, our bot processes data quickly to make accurate, profitable trading decisions with high efficiency.'
      },
      {
        title: 'Powerful Servers',
        description: 'We utilize high-end, reliable servers to ensure the bot runs smoothly 24/7 with the fastest transaction execution times on the market.'
      },
      {
        title: 'Customizable Strategy',
        description: 'Adjust Settings and customize your Strategy choose from diffrent settings and controll bot behavior '
      },
      {
        title: 'inteligent Trading',
        description: 'Bot Trades automatically picking high probability and profitable options with lower risk using inteligent algorithms'
      },
      {
        title: '99% Uptime',
        description: 'With a robust infrastructure, our bot offers 99.9% uptime, ensuring that you never miss a trading opportunity.'
      },
      {
        title: 'User-Friendly Interface',
        description: 'Our intuitive interface allows you to monitor and control your trades effortlessly, while providing real-time performance stats and insights.'
      },
    ],



  headline: 'High End Code on High Pieces Of Hardwares',
  description: 'Our trading bot uses private RPCs and a dedicated private node on Solana, ensuring lightning-fast trade execution and unmatched speed in picking up opportunities. Fully automated, it buys and sells instantly from your wallet, with real-time profit tracking and detailed stats. With a win rate between 60% to 85% (depending on the package), the bot leverages advanced AI technology to analyze data and make precise, profitable trades. so lets PUMP.FUN !!!'


}
export const BotFeaturesData = {

  featuresCards:
    [
      {
        title: 'Lightning-Fast Trades',
        description: 'Experience real-time trade execution like never before! With private RPCs and a dedicated Solana node, our bot ensures your trades are completed instantly, leaving no time for others to catch up.',
        img: img1
      }
      ,
      {
        title: 'Watch Your Profits Grow',
        description: 'Keep track of your trading success in real-time! Our bot updates stats continuously, so you can monitor your profits and adjust your strategies instantly as your portfolio grows.',
        img: img5
      }
      ,
      {
        title: 'AI That Sees the Market Like a Pro',
        description: 'Our bot leverages advanced AI to analyze market trends and make smart trades. It adapts to market conditions, ensuring your portfolio stays one step ahead, whether you re following predefined strategies or your own parameters.',
        img: img7
      }
      ,
      {
        title: 'Secure Trading',
        description: 'Let the bot take over the trading process while you relax. Fully automated and secure, it trades directly from your wallet 24/7, ensuring you never miss a chance to make a profit while keeping your assets safe.',
        img: img4
      }
    ],



  headline: ' Next-Level Trading with AI-Powered Precision',
  description: 'Our trading bot is designed to maximize your profits by executing trades faster than anyone else. Using advanced AI and private RPCs, it ensures you never miss a profitable opportunity on PUMP.FUN and Raydium. Let automation work for you while you sit back and watch the profits grow.'


}

export const HowItWorksData = {

  howItWorksCards:
    [
      {
        title: 'Connect wallet directly / remotely ',
        description: 'Our bot uses private Tools on Solana, ensuring lightning-fast trade execution and the ability to pick up trades faster than anyone else.',
        Icon: FaWallet,
      },
      {
        title: 'Set Auto or Own Parameters',
        description: 'The bot Picks up trades on your behalf , allowing for a completely hands-off trading experience.',
        Icon: IoSettings,
      },
      {
        title: 'Start Trading',
        description: 'Leveraging advanced AI technology, our bot processes data quickly to make accurate, profitable trading decisions with high efficiency.',
        Icon: FaChartLine,
      },

    ],



  headline: 'Your Trading Journey Starts Now.',
  description: 'Our trading bot operates seamlessly by connecting directly or remotely to your wallet and executing trades in real-time, ensuring you never miss an opportunity on PUMP.FUN , it processes data at lightning speed for faster execution than anyone else. With advanced AI technology, the bot analyzes market conditions and automatically buys or sells based on predefined strategies or your own customized parameters, optimizing your profits. The entire process is fully automated'


}



export const faqData = [
  {
    title: 'How does the trading bot work?',
    description: 'Our trading bot connects directly to your wallet and trades automatically based on real-time market analysis using advanced AI. It buys and sells on platforms like PUMP.FUN and Raydium, ensuring you never miss a profitable opportunity.',

  },
  {
    title: 'How fast is the bot’s trade execution?',
    description: 'The bot uses private RPCs and a dedicated Solana node, enabling lightning-fast execution. Trades are executed almost instantly, giving you a competitive edge in the market.',

  },
  {
    title: 'What’s the bot win rate?',
    description: 'The bot’s win rate typically ranges from 60% to 85%, depending on the package. It uses sophisticated AI to adapt to market conditions, maximizing your profits with each trade.',

  },
  {
    title: 'Can I customize the bot’s trading strategies?',
    description: 'Yes! You can choose from predefined strategies or customize your own parameters to align with your unique trading preferences. The bot adapts to your strategy for maximum profit.',

  },
  {
    title: 'Is my wallet secure when using the bot?',
    description: 'Absolutely! The bot operates with top-level security and trades directly from your wallet. Your private keys remain safe and the entire process is fully automated, minimizing any risk.',

  },
  {
    title: 'How do I track my profits and performance?',
    description: 'The bot provides real-time tracking of your trades and profits, offering detailed stats for each transaction. You’ll always know how well your trades are performing.',

  },
  {
    title: 'Is the bot 100% automated?',
    description: 'Yes, the bot runs fully automated, 24/7. Once you set it up, it handles all the trading and monitoring for you, ensuring you never miss a profitable moment.',

  },
  {
    title: 'What happens if the market changes quickly?',
    description: 'The bot’s AI technology constantly monitors the market for any significant changes. It automatically adjusts its strategy to ensure youre making profitable trades, even during sudden market shifts.',

  },

]



export const pricingData = [

  {
    id:1,
    title: 'BURNER',
    description: '+1k Phoenix Token each transaction',
    price: 0,
    data: [
      {
        title: 'Unlimited Usage',
        isActive: true,
      },
      {
        title: 'Proxied Connection',
        isActive: true,
      },
      {
        title: 'For starting',
        isActive: true,
      },
      {
        title: 'No Transaction Fees',
        isActive: false,
      },
      {
        title: 'Project owner wallet checker',
        isActive: false,
      },
      {
        title: 'Private Server',
        isActive: false,
      },
      {
        title: 'Guaranteed Results',
        isActive: false,
      },
      {
        title: 'Priority Support',
        isActive: false,
      },
    ]
  },
  {
    id:2,
    title: 'EXLPORER',
    description: '+ 0.1$ each transaction',
    price: 25,
    data: [
      {
        title: 'Unlimited Usage',
        isActive: true,
      },
      {
        title: 'Proxied Connection',
        isActive: true,
      },
      {
        title: 'For starting',
        isActive: true,
      },
      {
        title: 'No Transaction Fees',
        isActive: false,
      },
      {
        title: 'Project owner wallet checker',
        isActive: false,
      },

      {
        title: 'Private Server',
        isActive: false,
      },
      {
        title: 'Guaranteed Results',
        isActive: false,
      },
      {
        title: 'Priority Support',
        isActive: false,
      },
    ]
  },
  {
    id:3,
    title: 'DIAMOND',
    description: '0 Transaction Fees',
    price: 100,
    data: [
      {
        title: 'Unlimited Usage',
        isActive: true,
      },
      {
        title: 'Proxied Connection',
        isActive: true,
      },
      {
        title: 'For Day Traders',
        isActive: true,
      },
      {
        title: 'No Transaction Fees',
        isActive: true,
      },
      {
        title: 'Project owner wallet checker',
        isActive: true,
      },

      {
        title: 'Private Server',
        isActive: false,
      },
      {
        title: 'Guaranteed Results',
        isActive: true,
      },
      {
        title: 'Priority Support',
        isActive: true,
      },
    ]
  },
  {
    id:4,
    title: 'ELITE',
    description: '0 fees No Limits',
    price: 300,
    data: [
      {
        title: 'Unlimited Usage',
        isActive: true,
      },
      {
        title: 'Proxied Connection',
        isActive: true,
      },
      {
        title: 'For Advanced Usage',
        isActive: true,
      },
      {
        title: 'No Transaction Fees',
        isActive: true,
      },
      {
        title: 'Project owner wallet checker',
        isActive: true,
      },
      {
        title: 'High Performance Private RPC',
        isActive: true,
      },
      {
        title: 'Private Server',
        isActive: true,
      },
      {
        title: 'Guaranteed Results',
        isActive: true,
      },
      {
        title: 'Priority Support',
        isActive: true,
      },
    ]
  },
  {
    id:5,
    title: 'ENTREPRISE',
    description: 'Customize or create your Own',
    price: false,
    data: [
      {
        title: 'custom Bot',
        isActive: true,
      },
      {
        title: 'white Label',
        isActive: true,
      },


    ]
  },


]